import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

// "Water droplet with magnification" reveal: a circular ripple expands from
// center while the image settles from a magnified state to rest.
export const WaterDropReveal = ({ src, alt = "", className = "", origin = "50% 45%" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-100px" });
  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`} data-testid="waterdrop-reveal">
      <motion.div
        className="absolute inset-0"
        initial={{ clipPath: `circle(0% at ${origin})` }}
        animate={inView ? { clipPath: `circle(150% at ${origin})` } : {}}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
      >
        <motion.img
          src={src}
          alt={alt}
          draggable="false"
          className="w-full h-full object-cover"
          initial={{ scale: 1.35, filter: "blur(6px)" }}
          animate={inView ? { scale: 1, filter: "blur(0px)" } : {}}
          transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
        />
      </motion.div>
      {/* ripple ring */}
      <motion.span
        className="absolute rounded-full border border-white/40 pointer-events-none"
        style={{ left: origin.split(" ")[0], top: origin.split(" ")[1], translateX: "-50%", translateY: "-50%" }}
        initial={{ width: 0, height: 0, opacity: 0.6 }}
        animate={inView ? { width: "160%", height: "160%", opacity: 0 } : {}}
        transition={{ duration: 1.6, ease: "easeOut" }}
      />
    </div>
  );
};

export default WaterDropReveal;
